import React, { useState } from 'react';

import { IconLogo } from '$partials/icon';
import { Button } from '$partials/ui';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */
const offices = [
    {
        value: 'london',
        label: 'London'
    },
    {
        value: 'new-york',
        label: 'New York'
    },
    {
        value: 'paris',
        label: 'Paris'
    },
    {
        value: 'amsterdam',
        label: 'Amsterdam'
    }
];
/**
 * @type {import('$types/components/partials/global.d.ts').Footer}
 */
const Footer = (props) => {
    const [message, setMessage] = useState('');

    const handleOnSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const emailAddress = formData.get('emailAddress');

        if (emailAddress && props.mailchimpListId) {
            try {
                // send "add user to audience / list" request to our api endpoint
                const response = await fetch('/api/v1/mailchimp/subscribeOrUpdate', {
                    body: JSON.stringify({
                        emailAddress: emailAddress,
                        audienceListId: props.mailchimpListId,
                        status: 'pending'
                    }),
                    headers: {
                        'Content-type': 'application/json'
                    },
                    method: 'POST'
                });

                // convert response to json
                const result = await response.json();

                // if original request fails
                if (response.status !== 200) {
                    throw result;
                }

                // if server request fails
                if (result.status === 400) {
                    throw result;
                }

                // if request works
                setMessage('Thank you for subscribing! You\'ll receive a confirmation email shortly.');
            } catch (err) {
                if (err.message || err.title) {
                    switch (err.title) {
                        case 'Member Exists':
                            setMessage(`${emailAddress} is already a list member.`);
                            break;

                        case 'Invalid Resource':
                            setMessage(err.message || err.detail);
                            break;

                        default:
                            setMessage(err.message || 'Sorry something went wrong, please try again later.');
                            break;
                    }
                } else {
                    setMessage('Sorry something went wrong, please try again later.');
                }
            }
        }
    };
    return (
        <>
            <footer className={'h-[560px] bg-black py-16 flex flex-col justify-between overflow-x-hidden w-full sticky bottom-0 z-0'}>
                <div className='-mx-layout-col'>
                    <div className='flex flex-wrap w-full gap-y-32 px-layout-outer'>
                        <div
                            className='w-1/2 sm:w-3/7 md:w-1/7 px-layout-col text-text-default-invert'
                            dangerouslySetInnerHTML={{ __html: props.column1 }} />
                        <div
                            className='w-1/2 sm:w-3/7 md:w-1/7 px-layout-col text-text-default-invert'
                            dangerouslySetInnerHTML={{ __html: props.column2 }} />
                        <div className='w-1/2 sm:w-3/7 md:w-1/7 px-layout-col text-text-default-invert flex flex-col'>
                            {offices.map(office => {
                                return (
                                    <a
                                        href={`/?office=${office.value}`}
                                        key={office.value}>
                                        {office.label}
                                    </a>
                                );
                            })}
                        </div>
                        <div
                            className='w-1/2 sm:w-3/7 md:w-1/7 px-layout-col text-text-default-invert'
                            dangerouslySetInnerHTML={{ __html: props.column3 }} />
                        <div
                            className='w-1/2 sm:w-3/7 md:w-1/7 px-layout-col text-text-default-invert'
                            dangerouslySetInnerHTML={{ __html: props.column4 }} />
                        <form
                            className='w-full md:w-2/7 px-layout-col relative'
                            onSubmit={handleOnSubmit}>
                            <label
                                className='text-text-default-invert type-style-s'
                                htmlFor={'newsletter'}>
                                {'Newsletter'}
                            </label>
                            <input
                                required
                                className='w-full type-style-s text-text-default-invert bg-transparent border-b border-white rounded-none pb-5'
                                id={'newsletter'}
                                name='emailAddress'
                                placeholder='Email'/>
                            {message && (
                                <p className='text-text-default-invert type-style-s pt-4'>
                                    {message}
                                </p>
                            )}
                            <Button
                                className='absolute right-8 type-style-s top-28 text-text-default-invert'
                                type='submit'>
                                {'Submit'}
                            </Button>
                        </form>
                    </div>
                </div>
                <div className='px-layout-outer text-text-default-invert'>
                    <IconLogo/>
                </div>
            </footer>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Footer;
